import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Select } from 'antd';
import localStorage from '../../../utils/localStorage';

const { Option } = Select;

const SelectComponent = (props) => {
  const [optionList, setOptionList] = useState([]);
  const [formObject, setFormObject] = useState(props.formObject || {});
  const [Code, setCode] = useState(props.Code || '');
  const { api, ModuleCode, onSelectChange, placeholder } = props;

  useEffect(() => {
    setFormObject(props.formObject || {});
    setCode(props.Code || '');
  }, [props.formObject, props.Code]);

  useEffect(() => {
    _getOptionList(api);
  }, [api, ModuleCode]);

  const _getOptionList = async (api) => {
    const accessToken = localStorage.get('accessToken');
    const siteId = localStorage.get('currentSite');
    let objectHeader = {};

    if (api && api.url && api.method !== 'POST') {
      objectHeader = {
        method: 'GET',
        url: `${api.url}?SiteId=${siteId}&ModuleCode=${ModuleCode}`,
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };
    } else if (api && api.url && api.method && api.payload && api.method === 'POST') {
      objectHeader = {
        method: api.method,
        url: `${api.url}`,
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
        data: {
          SiteId: siteId,
          ModuleCode: ModuleCode,
        },
      };
    }

    try {
      const response = await axios(objectHeader);
      if (Array.isArray(response.data)) {
        setOptionList(response.data);
      }
    } catch (error) {
      console.error('Error fetching options:', error);
    }
  };

  return (
    <Select
      value={formObject && formObject[Code] ? formObject[Code] : null}
      onChange={onSelectChange}
      placeholder={placeholder}
    >
      {optionList &&
        Array.isArray(optionList) &&
        optionList.map((data, index) => (
          <Option key={index} value={data.Code}>
            {data.Name}
          </Option>
        ))}
    </Select>
  );
};

export default SelectComponent;
